package ui.widget

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*

@Composable
fun ErrUI() {
    Box(Modifier.fillMaxSize()) {
        Text("ERR", Modifier.align(Alignment.Center))
    }
}
